export default __webpack_public_path__ + "static/media/download.3dbbe2f2.svg";